export default "__VITE_ASSET__BR_8LiKU__"